/**
 * @taskId T649
 * @see functional/Cycles/cycle-5/tasks.md HU-25-FE
 */
import { Button } from '@flexibilitypay/ui';
import { cn } from '../../lib/utils';
import { PERIOD_OPTIONS, type DashboardPeriod } from './api';

interface PeriodSelectorProps {
  value: DashboardPeriod;
  onChange: (period: DashboardPeriod) => void;
  disabled?: boolean;
}

export function PeriodSelector({ value, onChange, disabled = false }: PeriodSelectorProps) {
  return (
    <div role="group" aria-label="Selector de período" className="flex gap-1">
      {PERIOD_OPTIONS.map((opt) => (
        <Button
          key={opt.value}
          size="sm"
          variant={value === opt.value ? 'default' : 'outline'}
          onClick={() => onChange(opt.value)}
          disabled={disabled}
          aria-pressed={value === opt.value}
          className={cn(
            'h-8 px-3 text-xs font-medium',
            value === opt.value && 'pointer-events-none',
          )}
        >
          {opt.label}
        </Button>
      ))}
    </div>
  );
}
